import * as React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { activated } from '../../redux/slices/Auth/login'
import { Box, styled, Stack } from '@mui/material'
import { Typography as MIUTypography, Button as BT } from '@mui/material'
import LoginIcon from '@mui/icons-material/Login'
import logo_unl from '../../assets/images/logo_unl.png'

const styleStack = {
  direction: 'column',
  alignItems: 'center',
  py: 2,
  px: '8vw',
  height: '100%',
  spacing: 2,
  width: '100%',
}

const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontSize: '1.125em',
  fontWeight: props.istitle ? 700 : 450,
  lineHeight: props.istitle ? '24px' : '24px',
  color: props.istitle ? '#1B1C37' : '#6A6A6A',
  textAlign: 'center',
}))

const styleImages = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  pt: 2,
}

const Button = styled(BT)(({ theme }) => ({
  color: '#FFF',
  backgroundColor: '#333333',
  '&:hover': { backgroundColor: '4F4F4F' },
  '&:focus': {
    boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
  },
}))

const LoginRequiredPage = props => {
  const dispatch = useDispatch()
  const _state = useSelector(state => state.drawerLeft)

  const styleBox = {
    marginLeft: _state.open ? _state.drawerWidth : 0,
    marginTop: _state.drawerHeight,
    height: _state.contentBox,
    width: 'inherit',
  }

  const handleClickLogin = () => {
    dispatch(activated(true))
  }

  return (
    <Box component="div" style={styleBox}>
      <Stack {...styleStack}>
        <Box>
          <Typography istitle="true">Proyecto 17-DI-FARNR-2021</Typography>
          <Typography istitle="true" sx={{ textTransform: 'uppercase' }}>
            “Dinámica de crecimiento y servicios ecosistémicos del arbolado urbano de la
            ciudad de Loja”
          </Typography>
        </Box>
        <Box sx={styleImages}>
          <Box component="div" sx={{ height: 100 }}>
            <img src={logo_unl} alt="Logo UNL" height="100%" />
          </Box>
        </Box>
        <Box pt={3}>
          <Typography istitle="true">{props.titlelb}</Typography>
        </Box>
        <Box pt={1}>
          <Typography sx={{ color: '#000', fontWeight: 500 }}>
            Se requiere que inicie sesión.
          </Typography>
        </Box>
        <Box pt={4}>
          <Box>
            <Button
              variant="contained"
              startIcon={<LoginIcon />}
              onClick={handleClickLogin}
              sx={{
                backgroundColor: '#004280',
                fontWeight: 600,
                fontSize: '0.8rem',
              }}>
              Iniciar Sesión
            </Button>
          </Box>
        </Box>
      </Stack>
    </Box>
  )
}

export default LoginRequiredPage
